package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickAnnouncementCreateRequest(
    @SerialName("school_id") val schoolId: String,
    val message: String,
    @SerialName("display_until") val displayUntil: String,
    val status: String = "DRAFT"
)

@Serializable
data class QuickAnnouncementUpdateRequest(
    val message: String? = null,
    @SerialName("display_until") val displayUntil: String? = null,
    val status: String? = null
)
